module.exports = __webpack_public_path__ + "static/media/mixcloud.2a519fb9.svg";